import { PERSONAL_MEETING_DESCRIPTION_PREFIX } from './constants';

export const createLobbyMessage = (title: string): string => {
  if (!title) {
    return 'Host will join the meeting soon.';
  }
  return `${title} — Host will join the meeting soon.`;
};

export const createWaitingMessage = (title: string): string => {
  if (!title) {
    return 'Please wait, the meeting host will let you in soon.';
  }
  return `${title} — Please wait, the meeting host will let you in soon.`;
};

export const generateNextMeetingTitle = (
  meetings: { description?: string | null }[],
  limit: number,
): string => {
  const existingNumbers = new Set(
    meetings.map((m) => parseInt(m.description?.match(/#(\d+)/)?.[1] ?? '0', 10)),
  );

  for (let i = 1; i <= limit; i++) {
    if (!existingNumbers.has(i)) {
      return `${PERSONAL_MEETING_DESCRIPTION_PREFIX}${i}`;
    }
  }

  return `${PERSONAL_MEETING_DESCRIPTION_PREFIX}${meetings.length + 1}`;
};
